<template>
  <div class="menuVertical fechado">
    <button class="openMenu">
      <div>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </div>
    </button>
    <button class="closeMenu" type="button">
      <i class="fas fa-outdent"></i>
    </button>
    <figure class="perfilUsuario">
      <img src="/static/resources/images/perfil.png" alt="Usuário" />
      <!-- <span class="nomeUsuario">Cláudia Emanuele da Silva</span> -->
    </figure>
    <ul class="itensPai">
      <li title="Regras de orçamento" v-on:click="goToRules()">
        <a href="#" class="menu cadastros">
          <i class="fas fa-clipboard-list"></i>
          <span>Regras de orçamento</span>
        </a>
      </li>
      <li title="Orçamentos" v-on:click="goToBudgets()">
        <a href="#" class="menu cadastros">
          <i class="fas fa-dollar-sign"></i>
          <span>Orçamentos</span>
        </a>
      </li>
      <!-- <li
        title="Serviços"
        v-on:click="alert()"
        style="cursor: default; opacity: 0.6"
      >
        <a href="#" class="menu cadastros">
          <i class="far fa-edit"></i>
          <span>Serviços</span>
        </a>
      </li> -->
      <!-- <li
        title="Clientes"
        v-on:click="goToBudgetsTests()"
        style="cursor: default; opacity: 0.6"
      >
        <a href="#" class="menu cadastros">
          <i class="fas fa-dollar-sign"></i>
          <span>Orçamentos Testes</span>
        </a>
      </li> -->
      <li
        title="Editar Email"
        v-on:click="goToBudgetsEditEmail()"
        style="cursor: default; opacity: 0.6"
      >
        <a href="#" class="menu cadastros">
          <i class="fa fa-envelope"></i>
          <span>Edição de Email</span>
        </a>
      </li>
      <li
        title="Editar Formulário"
        v-on:click="goToBudgetEditInfo()"
        style="cursor: default; opacity: 0.6"
      >
        <a href="#" class="menu cadastros">
          <i class="fa fa-text-width"></i>
          <span>Editar Fomulário</span>
        </a>
      </li>

      <li title="Sair">
        <a href="#" class="menu sair">
          <i class="fas fa-sign-out-alt" v-on:click="logout()"></i
          ><span>Sair</span></a
        >
      </li>
    </ul>
    <span class="version-informarion">v{{ version }}</span>
  </div>
</template>

<script>
const packageJson = require("../../../package.json");
export default {
  name: "toolbar",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      version: packageJson.version,
    };
  },
  mounted() {},
  methods: {
    async logout() {
      await this.$store.dispatch("auth/signOut");
      this.$router.push({ name: "auth" });
    },
    goToRules() {
      this.$router.push({ name: "dashboard>rules" });
    },
    goToBudgets() {
      this.$router.push({ name: "dashboard>budgets" });
    },
    goToBudgetsTests() {
      this.$router.push({ name: "dashboard>budgetsTests" });
    },
    goToBudgetsEditEmail() {
      this.$router.push({ name: "dashboard>editEmail" });
    },
    goToBudgetEditInfo() {
      this.$router.push({ name: "dashboard>budgetEditInfo" });
    },
    alert() {
      return this.$swal({
        type: "info",
        title: "Oops...",
        text: "Esta opção ainda não esta disponível!",
      });
    },
  },
};
</script>

<style scoped>
.version-informarion {
  margin: 5px;
  font-size: 10px;
  position: absolute;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav/Toolbar.vue